import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { removeOfflineSupport } from './utils/removeOfflineSupport';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// O suporte offline (PWA) está desativado. Esta chamada desinstala o service
// worker e apaga os dados de quem usou as versões anteriores; sem ela, esses
// navegadores continuariam presos ao app servido pelo cache antigo.
removeOfflineSupport();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
